/* eslint-disable global-require */
import React, { Suspense } from 'react'
// import React, { lazy, Suspense } from 'react'
import { Route, Routes, Navigate, useLocation, useParams, useNavigate } from 'react-router'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { connect } from 'react-redux'
import {
  getConfig,
  // removeTempEnvParam
} from 'env'

import { history as globalHistory } from 'index'

import { notifyMouseMove, deleteUMKFromLocal } from 'pUtils'
import { checkSearchParams } from 'utils'

import Layout from 'layouts'

export function withRouter(Component, options) {
  return (props) => {
    const newProps = {
      ...props,
    }

    newProps.location = useLocation()
    newProps.navigate = useNavigate()
    newProps.history = globalHistory
    newProps.match = {
      params: useParams(),
      path: newProps.location.pathname,
    }

    if (options != null && options.navigate === true) {
      newProps.navigate = useNavigate()
    }

    return <Component {...newProps} />
  }
}

const mapStateToProps = ({ menu, settings }) => ({
  myRoutes: menu.routerData,
  routerAnimation: settings.routerAnimation,
})

@connect(mapStateToProps)
class Router extends React.Component {
  cssRef = React.createRef()

  constructor(props) {
    super(props)
    // store.set('app.router.location', '');

    const { history } = props
    this.unsubscribeFromHistory = history.listen(this.handleLocationChange)
    this.handleLocationChange(history.location)

    document.addEventListener('mousemove', this.onMouseMove)
  }

  // componentDidMount() {
  //   window.addEventListener('unload', this.onUnload);
  // }

  // componentDidUpdate(prevProps) {
  //   const { location } = this.props
  //   // console.log(' ----  componentDidUpdate - searchPortal ', prevProps, prevState)
  //   if (prevProps != null && checkPageReplace(location, prevProps.location) === false) {
  //     console.log(' ----  params changed')
  //   }
  // }

  componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory()
    // window.removeEventListener('unload', this.onUnload);
    document.removeEventListener('mousemove', this.onMouseMove)
  }

  onMouseMove = () => {
    // console.log(' --- onMouseMove ')
    notifyMouseMove()
  }

  // onUnload = () => {
  //   deleteUMKFromLocal();
  //   removeTempEnvParam('rsaObj');
  // }

  handleLocationChange = (e) => {
    const { history } = this.props
    console.log('ROUTE CHANGED', e, history)
    if ((e.pathname === '' || e.pathname === '/') && e.key === 'default') {
      deleteUMKFromLocal()
    }

    checkSearchParams()
  }

  // const Router = ({ history, routerAnimation }) => {
  render = () => {
    const { routerAnimation, myRoutes, location } = this.props

    const defaultPage = getConfig('defaultPage')

    return (
      <Layout>
        <SwitchTransition>
          <CSSTransition
            key={location.pathname}
            appear
            nodeRef={this.cssRef}
            classNames={routerAnimation}
            timeout={routerAnimation === 'none' ? 0 : 300}
          >
            <Routes location={location}>
              <Route exact path="/" element={<Navigate to={defaultPage} />} />
              {myRoutes.map(({ path, Component }) => {
                return (
                  <Route
                    path={path}
                    key={path}
                    element={
                      <Suspense>
                        <div className={routerAnimation}>
                          <Component />
                        </div>
                      </Suspense>
                    }
                  />
                )
              })}
              <Route exact path="*" element={<Navigate to="/migration" />} />
            </Routes>
          </CSSTransition>
        </SwitchTransition>
      </Layout>
    )
  }
}

export default connect(mapStateToProps)(withRouter(Router))
